module.exports = __webpack_public_path__ + "img/together-we-go-far.9b7e4b1d.png";